import { render, staticRenderFns } from "./MomSubappOutlet.vue?vue&type=template&id=009d503c"
import script from "./MomSubappOutlet.vue?vue&type=script&lang=js"
export * from "./MomSubappOutlet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports